module.exports = "/images/Icon-5.svg?032813b046df03311668de2a0ff1c291";